import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Blocca click/navigazione/submit in demo:
 * - nessun link apre pagine
 * - nessun button esegue azioni
 * - Enter/Space non attiva controlli
 * Mantiene hover/animazioni visive (non usa pointer-events:none globale).
 */
export function DemoInteractionGuard({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const onClickCapture = (e: React.MouseEvent) => {
    const target = e.target as HTMLElement | null;
    if (!target) return;

    const interactive = target.closest("a, button, [role='button'], [role='link']");
    if (interactive) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const onSubmitCapture = (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const onKeyDownCapture = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      const interactive = target.closest("a, button, [role='button'], [role='link']");
      if (interactive) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  };

  return (
    <div
      className={cn(className)}
      onClickCapture={onClickCapture}
      onSubmitCapture={onSubmitCapture}
      onKeyDownCapture={onKeyDownCapture}
    >
      {children}
    </div>
  );
}
